module.exports = __webpack_public_path__ + "img/m_main.335892ed.jpg";